const processCertificate = (headers, list, payload, transData) => {
  let getHeaders = ''
  let getContent = ''
  for (let i = 0; i < headers.length; i++) {
    getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
  }
  for (let j = 0; j < list.length; j++) {
    getContent += '<tr>'
    for (let i = 0; i < headers.length; i++) {
      getContent += `<td class="th-fontsize">${list[j][headers[i].value] || ''}</td>`
    }
    getContent += '</tr>'
  }
  return content(getHeaders, getContent, payload, transData)
}
const content = (headers, content, payload, transData) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet" />
    <style>
      .footer {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
      }
      tbody tr { page-break-inside:avoid; }
      tbody tr td { word-break: break-word; }
      .table-bordered>tbody>tr>td, .table-bordered>tbody>tr>th, .table-bordered>tfoot>tr>td, .table-bordered>tfoot>tr>th, .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
        padding: 2.5px !important;
      }
    </style>
  </head>
  <body>
  <div class="container-fluid">
    <div class="col-xs-6">
      <table style="width: 100%">
        <tr>
          <th width="15%">${transData.orderNumber}:</th>
          <td width="15%">${payload.ordernumber}</td>
          <th width="15%">${transData.customer}:</th>
          <td width="15%">${payload.customername}</td>
        </tr>
        <tr>
          <th width="15%">${transData.orderDate}:</th>
          <td width="15%">${payload.date}</td>
          <th width="15%">${transData.supplier}:</th>
          <td width="15%">${payload.supplier}</td>
        </tr>
      </table>
    </div>
    <div class="col-xs-6">
      <img class="img-responsive pull-right" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
    </div>
    <div class="col-xs-12">
      <table class="table table-bordered" style="width: 100%">
        <tbody>
          <tr>
            ${headers}
          </tr>
          ${content}
        </tbody>
      </table>
    </div>
    <div class="col-xs-12">
      <p class="pr-10" style="padding-top:2px">
        Sertifikat utstedt av kilab AS.<br/>
        For internt bruk hos kunde.<br/>
      </p>
      <p class="mt-3">
        Sertifikatnr: ${payload.cernumber}
      </p>
    </div>
  </div>
</body>
</html>`)))
export default processCertificate
